import React, {Component} from 'react';
import './DublicateProject.css';
import Inputs from '../../../shared/FormComponents/Inputs';
import _ from 'lodash';

class DublicateProject extends Component {

  constructor(props) {
    super(props);
    this.defaultParams = {};
    this.state = {
        dublicatedProject: false,
        dublicateProject: {
            name : '',
        },
        inputStates: {
            name: false,
        }
    };
  }

    onDataChange = (key, value, valid) => {
        const state = _.extend({}, this.state);
        state.inputStates[key] = valid;
        state.dublicateProject[key] = value;
        this.setState(state, () => this.validateForm());
    };

    validateForm = () => {
        let validationStates = _.extend({}, this.state.inputStates);
        let key = Object.values(validationStates).indexOf(false) !== -1;
        let state = !key;
        this.setState({ formValid: state });
    }


    componentWillReceiveProps(nextProps){
        if(nextProps.dublicateData === 'success' &&  !this.state.dublicatedProject){
            this.props.openDropDown();
            //this.props.getProjectsList();
            this.setState({ dublicatedProject : true })
        }
    }

    closeDropDown = () => {

    }

    dublicateProject = () => {
        
        this.setState({ dublicatedProject : false })
        let data = {
            projectId: this.props.projectData.projectId,
            projectName: this.state.dublicateProject.name
        }
        this.props.dublicateProject(data);
        // dublicateData={this.props.dublicateData}
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='dublicate-content'>
                <p> Name the duplicate version of this project </p>
                <form>
                    <div className="form-group">
                        <Inputs
                            type="name"
                            className="form-control"
                            value={this.state.dublicateProject.name}
                            required={ true }
                            placeholder='Project Name'
                            onChange={ (value, valid) => this.onDataChange('name', value, valid)} />
                    </div>
                    <button
                        type="button"
                        onClick={() => this.dublicateProject()}
                        disabled={!this.state.formValid}
                        className="btn btn-success btn-mini">
                        Create 
                    </button>
                    <div 
                        onClick={() => this.props.openDropDown()} 
                        className="btn empty-btn default btn-mini">
                            Close
                    </div>
                </form>
            </div>
        )
    }
}

export default (DublicateProject);



// WEBPACK FOOTER //
// ./src/components/Toolkit/DublicateProject/DublicateProject.jsx